import { addGETParams } from '../../config'
import ax from '../api'
/*
 * setNotification - Set a notification item on the server
 * @param {string} notificationId - The id of the notification item
 * @param {object} full - The full object of the notification item
 * @returns {object} The response from the server
 */
export const setNotification = async (notificationId, full) => {
	const _url = addGETParams(`/management/notifications/set.php`, {
		notification_id: notificationId,
		...full
	})

	return await ax.post(_url)
}

/*
 * getNotificationsList - Retrieve a list of notification items from the server
 * @param {object} params - Parameters to filter and paginate the notifications list
 * @returns {object} The response from the server containing the list of notifications
 */
export const getNotificationsList = async (params) => {
	const _url = addGETParams(`/management/notifications/lst.php`, params)

	return await ax.post(_url)
}

/*
 * getNotification - Retrieve a specific notification item from the server
 * @param {string} notification_id - The id of the notification item to retrieve
 * @returns {object} The response from the server containing the notification item
 */
export const getNotification = async (notification_id) => {
	const _url = addGETParams(`/management/notifications/get.php`, {
		notification_id
	})

	return await ax.post(_url)
}
